<div class="about-page">

  <!-- HERO -->
  <section class="hero-section">
    <div class="hero-overlay"></div>

    <div class="hero-content">
      <h1>About Our School</h1>

      <p>
        Empowering young minds with knowledge, values, creativity,
        and confidence for a brighter future.
      </p>
    </div>
  </section>

  <!-- ABOUT INTRO -->
  <section class="content-section">
    <div class="container">
      <div class="section-title">
        <span>Who We Are</span>
      </div>

      <div class="intro-grid">

        <div class="intro-image">
          <img
            [src]="aboutUsImage || 'assets/images/about-school.jpg'"
            alt="School Building">
        </div>

        <div class="intro-content">

          <h2>Nurturing Excellence Since 1998</h2>

          <p>
            Our school is dedicated to providing a dynamic learning
            environment where students are encouraged to explore,
            innovate, and grow into responsible global citizens.
          </p>

          <p>
            Through academic excellence, character development,
            leadership opportunities, and co-curricular activities,
            we strive to unlock every learner’s full potential.
          </p>

          <p>
            We believe education extends beyond classrooms and focuses
            on preparing students for life with confidence,
            compassion, and critical thinking.
          </p>

        </div>

      </div>
    </div>
  </section>

  <!-- VISION MISSION -->
  <section class="vision-section">

    <div class="container">

      <div class="cards-grid">

        <div class="info-card">
          <mat-icon>visibility</mat-icon>

          <h3>Our Vision</h3>

          <p>
            To create lifelong learners who lead with integrity,
            innovation, and social responsibility.
          </p>
        </div>

        <div class="info-card">
          <mat-icon>flag</mat-icon>

          <h3>Our Mission</h3>

          <p>
            To provide holistic education through academic excellence,
            creativity, discipline, and inclusive opportunities.
          </p>
        </div>

      </div>

    </div>

  </section>

  <!-- STATS -->
  <section class="stats-section">

    <div class="container">

      <div class="stats-grid">

        <div class="stat-card">
          <h2>25+</h2>
          <p>Years of Excellence</p>
        </div>

        <div class="stat-card">
          <h2>3000+</h2>
          <p>Students</p>
        </div>

        <div class="stat-card">
          <h2>150+</h2>
          <p>Qualified Staff</p>
        </div>

        <div class="stat-card">
          <h2>100%</h2>
          <p>Commitment to Growth</p>
        </div>

      </div>

    </div>

  </section>

  <!-- WHY CHOOSE -->
  <section class="content-section">

    <div class="container">

      <div class="section-title">
        <span>Why Choose Us</span>
      </div>

      <div class="features-grid">

        <div class="feature-card">
          <mat-icon>school</mat-icon>
          <h4>Academic Excellence</h4>
          <p>Strong curriculum with innovative teaching methods.</p>
        </div>

        <div class="feature-card">
          <mat-icon>science</mat-icon>
          <h4>Modern Laboratories</h4>
          <p>Well-equipped labs for practical learning.</p>
        </div>

        <div class="feature-card">
          <mat-icon>sports_soccer</mat-icon>
          <h4>Sports & Fitness</h4>
          <p>Balanced development through sports activities.</p>
        </div>

        <div class="feature-card">
          <mat-icon>computer</mat-icon>
          <h4>Technology Enabled</h4>
          <p>Digital classrooms and smart learning resources.</p>
        </div>

        <div class="feature-card">
          <mat-icon>groups</mat-icon>
          <h4>Experienced Faculty</h4>
          <p>Dedicated educators focused on student success.</p>
        </div>

        <div class="feature-card">
          <mat-icon>emoji_events</mat-icon>
          <h4>Holistic Growth</h4>
          <p>Leadership, creativity, values, and confidence.</p>
        </div>

      </div>

    </div>

  </section>

  <!-- PRINCIPAL MESSAGE -->
  <section class="principal-section">

    <div class="container">

      <div class="principal-card">

        <div class="principal-image">
          <img
            src="assets/images/principal.jpg"
            alt="Principal">
        </div>

        <div class="principal-content">

          <h2>Principal's Message</h2>

          <p>
            Every child possesses unique talents and capabilities.
            Our goal is to inspire students to become curious learners,
            compassionate individuals, and confident leaders who make
            meaningful contributions to society.
          </p>

          <h5>Dr. Principal Name</h5>

        </div>

      </div>

    </div>

  </section>

</div>